module.exports = __webpack_public_path__ + "img/like.804287e2.svg";